import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Slide, ToastContainer } from 'react-toastify';
import PropTypes from 'prop-types';
import UserSection from './UserSection';
import WorkPreferences from './WorkPreferences';
import AnswersContainer from '../AnswersContainer';
import AnswerSection from '../common/AnswerSection';
import Reviews from './Reviews';
import PastProjects from './PastProjects';
import { getRequest, postRequest, putRequest } from '../../requestUtils';
import './ConsultantProfile.scss';
var ConsultantProfile = /*#__PURE__*/function (_Component) {
  function ConsultantProfile(props) {
    var _this;
    _classCallCheck(this, ConsultantProfile);
    _this = _callSuper(this, ConsultantProfile, [props]);
    var roles_available = _this.props.user.consultant_profile.roles_available;
    _this.state = {
      fullView: props.authorized,
      editMode: false,
      confirmationSent: false,
      percentage: props.percentage,
      sectionsNeedingAttention: props.sectionsNeedingAttention,
      rolesAvailable: roles_available,
      isPublic: props["public"],
      availableNow: props.availableNow,
      hourlyRate: props.hourlyRate,
      suggestedTags: props.suggestedTags,
      showSuggestionModal: ''
    };
    _this.toggleFullView = _this.toggleFullView.bind(_this);
    _this.togglePublic = _this.togglePublic.bind(_this);
    _this.toggleEditMode = _this.toggleEditMode.bind(_this);
    _this.updateCompletionPercentage = _this.updateCompletionPercentage.bind(_this);
    _this.updateAvailability = _this.updateAvailability.bind(_this);
    _this.updateHourlyRate = _this.updateHourlyRate.bind(_this);
    _this.updateSuggestedTags = _this.updateSuggestedTags.bind(_this);
    _this.navigateToSection = _this.navigateToSection.bind(_this);
    return _this;
  }
  _inherits(ConsultantProfile, _Component);
  return _createClass(ConsultantProfile, [{
    key: "toggleFullView",
    value: function toggleFullView() {
      var fullView = this.state.fullView;
      this.setState({
        fullView: !fullView
      });
    }
  }, {
    key: "toggleEditMode",
    value: function toggleEditMode() {
      this.setState({
        editMode: !this.state.editMode
      });
    }
  }, {
    key: "togglePublic",
    value: function togglePublic() {
      var _this2 = this;
      var isPublic = this.state.isPublic;
      var _this$props = this.props,
        updatePublicUrl = _this$props.updatePublicUrl,
        csrfToken = _this$props.csrfToken;
      putRequest(updatePublicUrl, {
        "public": !isPublic
      }, csrfToken).then(function () {
        _this2.setState({
          isPublic: !isPublic
        });
      });
    }
  }, {
    key: "handleSendConfirmation",
    value: function handleSendConfirmation() {
      var _this3 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        confirmUrl = _this$props2.confirmUrl,
        user = _this$props2.user;
      postRequest(confirmUrl, {
        email: user.email
      }, csrfToken).then(function () {
        _this3.setState({
          confirmationSent: true
        });
      });
    }
  }, {
    key: "updateCompletionPercentage",
    value: function updateCompletionPercentage() {
      var _this4 = this;
      var _this$props3 = this.props,
        questionnaireId = _this$props3.questionnaireId,
        user = _this$props3.user;
      getRequest("/users/".concat(user.resource_id, "/completion_percentage?questionnaire_id=").concat(questionnaireId)).then(function (response) {
        _this4.setState({
          percentage: response.data.value,
          rolesAvailable: response.data.roles_available,
          sectionsNeedingAttention: response.data.sections_needing_attention
        });
      });
    }
  }, {
    key: "updateAvailability",
    value: function updateAvailability(answer) {
      this.setState({
        availableNow: answer
      });
    }
  }, {
    key: "updateSuggestedTags",
    value: function updateSuggestedTags(tags, type) {
      var suggestedTags = this.state.suggestedTags;
      var showSuggestionModal = tags.length ? type : null;
      suggestedTags[type] = tags;
      this.setState({
        suggestedTags: suggestedTags,
        showSuggestionModal: showSuggestionModal
      });
    }
  }, {
    key: "updateHourlyRate",
    value: function updateHourlyRate(answer) {
      this.setState({
        hourlyRate: answer
      });
    }
  }, {
    key: "navigateToSection",
    value: function navigateToSection(questionCategoryId) {
      this.setState({
        editMode: true
      }, function () {
        var el = document.getElementById("question-category-".concat(questionCategoryId));
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          el.setAttribute('tabIndex', '-1');
          el.focus({
            preventScroll: true
          });
        }
      });
    }
  }, {
    key: "sectionNeedsAttention",
    value: function sectionNeedsAttention(questionCategoryId) {
      var sectionsNeedingAttention = this.state.sectionsNeedingAttention;
      return sectionsNeedingAttention.some(function (section) {
        return section.question_category_id === questionCategoryId;
      });
    }
  }, {
    key: "renderConfirmationAction",
    value: function renderConfirmationAction() {
      var _this5 = this;
      var _this$props4 = this.props,
        user = _this$props4.user,
        proposalResourceId = _this$props4.proposalResourceId;
      var confirmationSent = this.state.confirmationSent;
      if (!user.confirmed) {
        if (confirmationSent) {
          return /*#__PURE__*/React.createElement("div", {
            className: "confirmation-action body-text-2"
          }, "Confirmation Email Sent!");
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "confirmation-action body-text-2"
        }, "Oh! You need to confirm your email!", /*#__PURE__*/React.createElement("a", {
          className: "reconfirm-email-link",
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return _this5.handleSendConfirmation();
          }
        }, ' ', "Get confirmation email"));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "confirmation-action"
      }, user.confirmed && proposalResourceId && /*#__PURE__*/React.createElement("a", {
        className: "body-text-2 medium-weight",
        href: "/proposals/".concat(proposalResourceId)
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-left"
      }), "Back to proposal"));
    }
  }, {
    key: "renderProfileActions",
    value: function renderProfileActions() {
      var _this6 = this;
      var _this$props5 = this.props,
        authorized = _this$props5.authorized,
        proposalResourceId = _this$props5.proposalResourceId,
        clorifyUrl = _this$props5.clorifyUrl,
        isRep = _this$props5.isRep,
        user = _this$props5.user;
      var _this$state = this.state,
        editMode = _this$state.editMode,
        fullView = _this$state.fullView;
      if (authorized) {
        return /*#__PURE__*/React.createElement("div", {
          className: "actions consultant-profile-actions d-none d-md-flex"
        }, this.renderConfirmationAction(), /*#__PURE__*/React.createElement("div", {
          className: "right-actions d-flex justify-content-end gap-2 align-items-center"
        }, /*#__PURE__*/React.createElement("a", {
          role: "button",
          tabIndex: 0,
          id: "profile-page-".concat(fullView ? 'public' : 'private', "-view-button"),
          className: "",
          onClick: function onClick() {
            return _this6.toggleFullView();
          }
        }, fullView ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-eye"
        }) : /*#__PURE__*/React.createElement("i", {
          className: "fa fa-eye-slash"
        }), fullView ? 'View Public Profile' : 'Back to Private View'), fullView && isRep && /*#__PURE__*/React.createElement("a", {
          role: "button",
          target: "_blank",
          tabIndex: 0,
          id: "view-clorify-button",
          className: "btn btn-secondary",
          href: clorifyUrl,
          rel: "noreferrer"
        }, "View Clorify"), fullView && isRep && /*#__PURE__*/React.createElement("a", {
          role: "button",
          tabIndex: 0,
          id: "leave-internal-feedback-button",
          className: "btn btn-primary ms-2 me-3",
          href: "/consultant_reviews/new?consultant_id=".concat(user.id, "&include_project=false")
        }, "Leave Feedback"), fullView && /*#__PURE__*/React.createElement("a", {
          role: "button",
          tabIndex: 0,
          id: "profile-page-edit-button",
          className: "btn btn-primary",
          onClick: function onClick() {
            return _this6.toggleEditMode();
          },
          style: {
            height: 'max-content'
          }
        }, editMode ? 'Finish Editing' : 'Edit Profile')));
      }
      if (proposalResourceId !== null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "actions consultant-profile-actions"
        }, /*#__PURE__*/React.createElement("a", {
          className: "body-text-2 medium-weight",
          href: "/proposals/".concat(proposalResourceId)
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-chevron-left"
        }), "Back to proposal"));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$props6 = this.props,
        user = _this$props6.user,
        csrfToken = _this$props6.csrfToken,
        questionnaireId = _this$props6.questionnaireId,
        questionnaireName = _this$props6.questionnaireName,
        settingsUrl = _this$props6.settingsUrl,
        connectUrl = _this$props6.connectUrl,
        inviteUrl = _this$props6.inviteUrl,
        searchEnabled = _this$props6.searchEnabled,
        query = _this$props6.query,
        uninvitedColleagues = _this$props6.uninvitedColleagues,
        invitedColleagues = _this$props6.invitedColleagues,
        workLocationOptions = _this$props6.workLocationOptions,
        durationOptions = _this$props6.durationOptions,
        timePerWeekOptions = _this$props6.timePerWeekOptions,
        inviterEmailDomain = _this$props6.inviterEmailDomain,
        previouslyConsultedForEmployer = _this$props6.previouslyConsultedForEmployer,
        fromProject = _this$props6.fromProject,
        claimInfoUrl = _this$props6.claimInfoUrl,
        isReadingMore = _this$props6.isReadingMore,
        availabilityModalOpen = _this$props6.availabilityModalOpen;
      var _this$state2 = this.state,
        fullView = _this$state2.fullView,
        editMode = _this$state2.editMode,
        percentage = _this$state2.percentage,
        sectionsNeedingAttention = _this$state2.sectionsNeedingAttention,
        rolesAvailable = _this$state2.rolesAvailable,
        isPublic = _this$state2.isPublic,
        availableNow = _this$state2.availableNow,
        hourlyRate = _this$state2.hourlyRate,
        suggestedTags = _this$state2.suggestedTags,
        showSuggestionModal = _this$state2.showSuggestionModal;
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide consultant-profile container"
      }, /*#__PURE__*/React.createElement(ToastContainer, {
        position: "bottom-center",
        transition: Slide,
        hideProgressBar: true,
        autoClose: 8000,
        closeOnClick: true,
        draggable: false,
        pauseOnHover: true,
        pauseOnFocusLoss: true,
        className: "cancelled-interview-toast-container",
        toastClassName: "cancelled-interview-toast",
        bodyClassName: "cancelled-interview-toast-body"
      }), fromProject && /*#__PURE__*/React.createElement("a", {
        id: "back-to-project",
        href: "/projects/".concat(fromProject),
        className: "btn btn-secondary-no-border back-to-project-link"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-left"
      }), /*#__PURE__*/React.createElement("span", {
        className: "back-to-project-text"
      }, "Back to project")), this.renderProfileActions(), /*#__PURE__*/React.createElement("div", {
        className: "consultant-profile-body mt-3"
      }, /*#__PURE__*/React.createElement(UserSection, {
        firstName: user.first_name,
        lastName: user.last_name,
        editMode: editMode,
        fullView: fullView,
        csrfToken: csrfToken,
        settingsUrl: settingsUrl,
        inviteUrl: inviteUrl,
        questionableId: user.consultant_profile.id,
        questionableType: user.consultant_profile.questionable_type,
        questionnaireId: questionnaireId,
        questionnaireName: questionnaireName,
        questionCategoryId: user.consultant_profile.user_section_question_category_id,
        userSectionQuestionnaireQuestions: user.consultant_profile.user_section_questionnaire_questions,
        rolesQuestionnaireQuestions: user.consultant_profile.roles_questionnaire_questions,
        updateCompletionPercentage: this.updateCompletionPercentage,
        rolesAvailable: rolesAvailable,
        togglePublic: this.togglePublic,
        isPublic: isPublic,
        percentage: percentage,
        sectionsNeedingAttention: sectionsNeedingAttention,
        onSectionClick: this.navigateToSection,
        connectUrl: connectUrl,
        resourceId: user.resource_id,
        availableNow: availableNow && availableNow.value === 'yes',
        hourlyRate: hourlyRate,
        ratingAvg: user.rating_avg,
        reviewsLength: user.reviews.length,
        searchEnabled: searchEnabled,
        query: query,
        uninvitedColleagues: uninvitedColleagues,
        invitedColleagues: invitedColleagues,
        workLocationOptions: workLocationOptions,
        durationOptions: durationOptions,
        timePerWeekOptions: timePerWeekOptions,
        id: user.consultant_profile.id,
        userId: user.id,
        favoriteId: user.consultant_profile.user_favorite_id,
        inviterEmailDomain: inviterEmailDomain,
        showHireAgain: previouslyConsultedForEmployer,
        suggestedTags: suggestedTags,
        showSuggestionModal: showSuggestionModal,
        updateSuggestedTags: this.updateSuggestedTags,
        fromProject: fromProject,
        consultantInitials: user.name_initials,
        receivedProposals: user.project_invitations
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "consultant-profile-left"
      }, /*#__PURE__*/React.createElement("div", {
        id: "question-category-".concat(user.consultant_profile.work_preference_question_category_id)
      }, /*#__PURE__*/React.createElement(WorkPreferences, {
        questionableId: user.consultant_profile.id,
        questionableType: user.consultant_profile.questionable_type,
        questionnaireId: questionnaireId,
        questionnaireName: questionnaireName,
        questionCategoryId: user.consultant_profile.work_preference_question_category_id,
        questionnaireQuestions: user.consultant_profile.work_preferences_questionnaire_questions,
        fullView: fullView,
        csrfToken: csrfToken,
        claimInfoUrl: claimInfoUrl,
        editMode: editMode,
        userId: user.resource_id,
        updateCompletionPercentage: this.updateCompletionPercentage,
        updateAvailability: this.updateAvailability,
        updateHourlyRate: this.updateHourlyRate,
        showModal: availabilityModalOpen,
        onAttentionClick: this.navigateToSection,
        needsAttention: this.sectionNeedsAttention(user.consultant_profile.work_preference_question_category_id)
      })), user.reviews.length ? /*#__PURE__*/React.createElement(Reviews, {
        reviews: user.reviews
      }) : '', user.past_clora_projects.length ? /*#__PURE__*/React.createElement(PastProjects, {
        projects: user.past_clora_projects
      }) : '', /*#__PURE__*/React.createElement(AnswersContainer, {
        categories: user.consultant_profile.left_side_question_categories,
        questionableId: user.consultant_profile.id,
        questionableType: user.consultant_profile.questionable_type,
        fullView: fullView,
        csrfToken: csrfToken,
        editMode: editMode,
        questionnaireId: questionnaireId,
        questionnaireName: questionnaireName,
        updateCompletionPercentage: this.updateCompletionPercentage,
        sectionsNeedingAttention: sectionsNeedingAttention,
        onSectionClick: this.navigateToSection
      })), /*#__PURE__*/React.createElement("div", {
        className: "consultant-profile-right"
      }, /*#__PURE__*/React.createElement("div", {
        id: "question-category-".concat(user.consultant_profile.bio_question_category_id)
      }, /*#__PURE__*/React.createElement(AnswerSection, {
        customClass: "bio-section",
        key: user.consultant_profile.bio_question_category_id,
        questionCategoryId: user.consultant_profile.bio_question_category_id,
        title: "Bio",
        questionableId: user.consultant_profile.id,
        questionableType: user.consultant_profile.questionable_type,
        fullView: fullView,
        csrfToken: csrfToken,
        editMode: editMode,
        questionnaireName: questionnaireName,
        updateCompletionPercentage: this.updateCompletionPercentage,
        suggestedTags: suggestedTags,
        updateSuggestedTags: this.updateSuggestedTags,
        showSuggestionModal: showSuggestionModal,
        isReadingMore: isReadingMore,
        needsAttention: this.sectionNeedsAttention(user.consultant_profile.bio_question_category_id),
        onAttentionClick: this.navigateToSection
      })), /*#__PURE__*/React.createElement("div", {
        id: "question-category-".concat(user.consultant_profile.past_roles_category_id)
      }, /*#__PURE__*/React.createElement(AnswerSection, {
        customClass: "past-roles-section",
        questionCategoryId: user.consultant_profile.past_roles_category_id,
        questionableId: user.consultant_profile.id,
        questionableType: user.consultant_profile.questionable_type,
        csrfToken: csrfToken,
        questionnaireId: questionnaireId,
        questionnaireName: questionnaireName,
        fullView: fullView,
        editMode: editMode,
        hideFooterButton: true,
        updateCompletionPercentage: this.updateCompletionPercentage,
        needsAttention: this.sectionNeedsAttention(user.consultant_profile.past_roles_category_id),
        onAttentionClick: this.navigateToSection,
        isReadingMore: isReadingMore
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AnswersContainer, {
        categories: user.consultant_profile.question_categories,
        questionableId: user.consultant_profile.id,
        questionableType: user.consultant_profile.questionable_type,
        fullView: fullView,
        csrfToken: csrfToken,
        editMode: editMode,
        questionnaireId: questionnaireId,
        questionnaireName: questionnaireName,
        updateCompletionPercentage: this.updateCompletionPercentage,
        suggestedTags: suggestedTags,
        updateSuggestedTags: this.updateSuggestedTags,
        showSuggestionModal: showSuggestionModal,
        sectionsNeedingAttention: sectionsNeedingAttention,
        onSectionClick: this.navigateToSection
      }))))), fullView && /*#__PURE__*/React.createElement("div", {
        className: "sticky-edit d-block d-md-none"
      }, /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        id: "profile-page-edit-button",
        className: "btn btn-primary",
        onClick: function onClick() {
          return _this7.toggleEditMode();
        },
        style: {
          height: 'max-content'
        }
      }, editMode ? 'Finish Editing' : 'Edit Profile')));
    }
  }]);
}(Component);
ConsultantProfile.propTypes = {
  percentage: PropTypes.number.isRequired,
  sectionsNeedingAttention: PropTypes.arrayOf(PropTypes.shape({})),
  user: PropTypes.shape({}).isRequired,
  confirmUrl: PropTypes.string,
  authorized: PropTypes.bool,
  csrfToken: PropTypes.string,
  questionnaireId: PropTypes.number.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  settingsUrl: PropTypes.string.isRequired,
  inviteUrl: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string,
  "public": PropTypes.bool.isRequired,
  updatePublicUrl: PropTypes.string,
  connectUrl: PropTypes.string.isRequired,
  availableNow: PropTypes.shape({}).isRequired,
  hourlyRate: PropTypes.shape({}).isRequired,
  searchEnabled: PropTypes.bool.isRequired,
  query: PropTypes.number,
  uninvitedColleagues: PropTypes.arrayOf(PropTypes.shape({})),
  invitedColleagues: PropTypes.arrayOf(PropTypes.shape({})),
  workLocationOptions: PropTypes.shape({}).isRequired,
  durationOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  timePerWeekOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  inviterEmailDomain: PropTypes.string,
  previouslyConsultedForEmployer: PropTypes.bool,
  suggestedTags: PropTypes.shape({}),
  clorifyUrl: PropTypes.string.isRequired,
  isRep: PropTypes.bool,
  fromProject: PropTypes.string,
  claimInfoUrl: PropTypes.string.isRequired,
  isReadingMore: PropTypes.bool,
  availabilityModalOpen: PropTypes.bool
};
ConsultantProfile.defaultProps = {
  authorized: false,
  confirmUrl: '#',
  csrfToken: '',
  proposalResourceId: null,
  updatePublicUrl: '',
  query: null,
  inviterEmailDomain: '',
  previouslyConsultedForEmployer: false,
  suggestedTags: {},
  isRep: false,
  invitedColleagues: [],
  uninvitedColleagues: [],
  fromProject: null,
  isReadingMore: false,
  availabilityModalOpen: false,
  sectionsNeedingAttention: []
};
export default ConsultantProfile;